document.addEventListener('DOMContentLoaded', () => {

	/* ---------------------------------------------------------
	 * 1. FILTRAGE DES ÉVÉNEMENTS (mobile & desktop)
	 * --------------------------------------------------------- */

	let filterLinks;

	if (window.screen.width > 1340) {
		filterLinks = document.querySelectorAll('.iso-list-ecoles a');
	} else {
		filterLinks = document.querySelectorAll('.menu-campus-select a');
	}

	filterLinks.forEach(link => {
		link.addEventListener('click', e => {
			e.preventDefault();

			// Enlever la sélection des autres liens
			filterLinks.forEach(l => l.classList.remove('selected'));
			link.classList.add('selected');

			// Conteneur de la grille
			const grid = document.querySelector('.iso-events-grid');
			if (!grid) return;

			// Tous les events
			const events = grid.querySelectorAll('.iso-card-event');

			// Cacher tout d'abord
			events.forEach(event => {
				event.classList.add('hidden');
				event.style.display = 'none';
			});

			// Campus sélectionné
			const campusName = link.getAttribute('data-ecole');

			// Filtrage
			events.forEach(event => {
				if (
					campusName === 'tous-les-campus' ||
					event.classList.contains(`iso-campus-${campusName}`) ||
					event.classList.contains('iso-campus-iso')
				) {
					event.style.display = 'block';
					setTimeout(() => event.classList.remove('hidden'), 20);
				}
			});

			// Suppression du form_event comme dans ton script original
			const fromScript = e.currentTarget.dataset.fromScript === "1";
			if (!fromScript) {
				const formEvent = document.getElementById('iso-form-event');
				if (formEvent) {
					formEvent.remove();
				}
			}

			/* ---------------------------------------------------------
			 * MESSAGE "Aucun évènement"
			 * --------------------------------------------------------- */

			setTimeout(() => {
				const visibleEvents = Array.from(events).filter(ev => ev.style.display === 'block');

				// Création du message si pas encore existant
				let noEventMsg = document.querySelector('.iso-no-event-message');
				if (!noEventMsg) {
					noEventMsg = document.createElement('div');
					noEventMsg.className = 'iso-no-event-message';
					noEventMsg.textContent = "Pas d'évènement pour le moment sur ce campus";
					noEventMsg.style.display = 'none';
					noEventMsg.style.marginTop = '20px';
					noEventMsg.style.textAlign = 'center';
					grid.parentNode.insertBefore(noEventMsg, grid.nextSibling);
				}

				// Affiche ou cache
				if (visibleEvents.length === 0) {
					noEventMsg.style.display = 'block';
				} else {
					noEventMsg.style.display = 'none';
				}

			}, 50);

		});
	});

	// Déclenche automatiquement le campus sélectionné au chargement
	const selectedLink = Array.from(filterLinks).find(link => link.classList.contains('selected'));
	if (selectedLink) {
		selectedLink.dataset.fromScript = "1";
		selectedLink.click();
		delete selectedLink.dataset.fromScript;
	}


	/* ---------------------------------------------------------
	 * 2. MENU MOBILE (custom select)
	 * --------------------------------------------------------- */

	document.querySelectorAll('.menu-campus-select').forEach(menu => {
		const button = menu.querySelector('.menu-campus-select__button');
		const label  = menu.querySelector('.menu-campus-select__label');
		const menuMobile = menu.querySelector('.menu-campus-list');

		if (!menuMobile) return;

		const links = menuMobile.querySelectorAll('a');

		// Ouvre / ferme le menu
		function toggle(open) {
			const willOpen = (typeof open === 'boolean') ? open : !menu.classList.contains('open');

			if (willOpen) {
				menu.classList.add('open');
				menu.setAttribute('aria-expanded', 'true');
			} else {
				menu.classList.remove('open');
				menu.setAttribute('aria-expanded', 'false');
			}
		}

		// Ouvre/ferme avec le bouton
		button.addEventListener('click', () => toggle());

		// Mise à jour label + fermeture, filtrage géré par script principal
		links.forEach(link => {
			link.addEventListener('click', () => {
				label.textContent = link.textContent;
				toggle(false);
			});
		});

		// Clic extérieur → fermeture
		document.addEventListener('click', e => {
			if (!menu.contains(e.target) && menu.classList.contains('open')) {
				toggle(false);
			}
		});
	});


	/* ---------------------------------------------------------
	 * 3. Debug hashchange (inchangé)
	 * --------------------------------------------------------- */
	window.addEventListener("hashchange", function () {
		console.log("Nouvelle URL (hash):", location.href);
	});
});
